module.exports = __webpack_public_path__ + "img/palestra.4a562f88.png";